<div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <div class="d-flex justify-content-between">
          <h4 class="font-weight-bold text-dark py">REQUEST A COURSE</h4>
        </div>
      </div>
      <div class="p-3">
        <div class="table-responsive" *ngIf="customers.length > 0; else noDataTemplate">
          <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>Requested Course</th>
                <th>No Of Students</th>
                <th>Name</th>
                <th>Phone</th>
                <th>District</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let customer of customers">
                <td>{{ customer.requested_course }}</td>
                <td>{{ customer.student_count }}</td>
                <td>{{ customer.name }}</td>
                <td>{{ customer.number }}</td>
                <td>{{ customer.district }}</td>
                <!-- <td>{{ customer.status }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noDataTemplate>
          <div class="d-flex justify-content-center">
            <p>No data available.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>